import * as React from "react";
const SvgFiRrTimeForwardSixty = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-time-forward-sixty_svg__a)">
      <path
        fill="#062147"
        d="M14 18c-.34 0-.678.057-1 .17V18a1 1 0 0 1 1.75-.661 1 1 0 1 0 1.5-1.322A3 3 0 0 0 11 18v3a3 3 0 0 0 5.544 1.589 3.06 3.06 0 0 0 .121-3.01A2.94 2.94 0 0 0 14 18m.85 3.529a1.001 1.001 0 1 1-.85-1.53.95.95 0 0 1 .866.456 1.07 1.07 0 0 1-.017 1.074m6.15-6.53a3 3 0 0 0-3 3v3a3 3 0 0 0 6 0v-3a3 3 0 0 0-3-3m1 6a1 1 0 0 1-2 0v-3a1 1 0 1 1 2 0zm-10-8H8a1 1 0 0 1 0-2h3V7a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1M24 3v3a3 3 0 0 1-3 3h-3a1 1 0 1 1 0-2h2.637A9.992 9.992 0 1 0 8.364 21.319a1 1 0 1 1-.728 1.864A12 12 0 1 1 22 5.374V3a1 1 0 1 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-time-forward-sixty_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTimeForwardSixty;
